import { post } from "../utils/backend";
import { useLongfansMock } from "../global/GlobalMock";
import { mockCreateOrder, mockPreparePay, mockQueryPayStatus } from "./StoreOrderMock";
import type {
  CreateStoreOrderResult,
  ListMyOrdersQuery,
  ListMyStoreOrdersResult,
  MyStoreOrderDetailResult,
  PreparePayParamBody,
  PreparePayResult,
  QueryPayStatusParamBody,
  QueryPayStatusResult,
  SubmitStoreAfterSaleResult,
} from "./StoreOrderType";

/** 关闭店铺订单 mock 时保持 `&& false`（见 frontend-data-mock-rule）。 */
const mockStoreOrder = false;

export const StoreOrderApi = {
  createOrder: (p: {
    spaceId: string;
    spaceProductId: string;
    serviceTier: string;
    subProductItemId?: string;
  }): Promise<CreateStoreOrderResult | string> => {
    if (useLongfansMock && mockStoreOrder) {
      return mockCreateOrder(p);
    }
    return post<typeof p, CreateStoreOrderResult>("/lark/app/storeOrder/create", p);
  },
  signAgreement: (p: {
    spaceId: string;
    spaceProductId: string;
    templateId: string;
  }): Promise<unknown | string> =>
    post<typeof p, unknown>("/lark/app/storeOrder/signProductAgreement", p),
  preparePay: (
    p: PreparePayParamBody,
    options?: { silent?: boolean }
  ): Promise<PreparePayResult | string> => {
    if (useLongfansMock && mockStoreOrder) {
      return Promise.resolve(mockPreparePay(p));
    }
    return post<typeof p, PreparePayResult>("/lark/app/storeOrder/preparePay", p, options);
  },
  queryPayStatus: (p: QueryPayStatusParamBody): Promise<QueryPayStatusResult | string> => {
    if (useLongfansMock && mockStoreOrder) {
      return Promise.resolve(mockQueryPayStatus(p));
    }
    return post<typeof p, QueryPayStatusResult>(
      "/lark/app/storeOrder/queryPayStatus",
      p,
      { silent: true }
    );
  },
  listMyOrders: (p: ListMyOrdersQuery) =>
    post<typeof p, ListMyStoreOrdersResult>("/lark/app/storeOrder/listMyOrders", p),
  getMyOrderDetail: (p: { spaceId: string; orderId: string }) =>
    post<typeof p, MyStoreOrderDetailResult>(
      "/lark/app/storeOrder/getMyOrderDetail",
      p
    ),
  submitAfterSale: (p: {
    spaceId: string;
    orderId: string;
    afterType: "refund" | "extend_service";
    reason: string;
  }) =>
    post<typeof p, SubmitStoreAfterSaleResult>(
      "/lark/app/storeOrder/submitAfterSale",
      p
    ),
};
